import { z } from 'zod';
import { listOf, pageOf } from './common';
import { defineContract } from './contract';

export const tenantStatusSchema = z.enum(['active', 'suspended', 'disabled']);
export type TenantStatus = z.infer<typeof tenantStatusSchema>;

export const tenantSchema = z.object({
  id: z.string(),
  slug: z.string(),
  name: z.string(),
  status: tenantStatusSchema,
  defaultLocale: z.string().nullable(),
  defaultTimezone: z.string().nullable(),
  version: z.number().int(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type Tenant = z.infer<typeof tenantSchema>;

export const myTenantSchema = z.object({
  tenant: tenantSchema,
  membership: z.object({ id: z.string(), joinedAt: z.string() }),
});
export type MyTenant = z.infer<typeof myTenantSchema>;

export const tenantPageSchema = pageOf(tenantSchema);

export const createTenantBody = z.strictObject({ name: z.string(), slug: z.string().optional() });
export type CreateTenantBody = z.infer<typeof createTenantBody>;

export const updateTenantBody = z.strictObject({
  name: z.string(),
  defaultLocale: z.string().max(35).nullish(),
  defaultTimezone: z.string().max(64).nullish(),
  version: z.number().int().positive(),
});
export type UpdateTenantBody = z.infer<typeof updateTenantBody>;

export const tenantsContracts = {
  mine: defineContract({ method: 'GET', path: '/tenants', response: listOf(myTenantSchema) }),
  create: defineContract({
    method: 'POST',
    path: '/tenants',
    body: createTenantBody,
    response: tenantSchema,
  }),
  current: defineContract({ method: 'GET', path: '/tenants/current', response: tenantSchema }),
  update: defineContract({
    method: 'PATCH',
    path: '/tenants/current',
    body: updateTenantBody,
    response: tenantSchema,
  }),
};
